import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import TablePagination from '@material-ui/core/TablePagination';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import withWidth from '@material-ui/core/withWidth';

import StockDetail from '../mobile/StockDetail'
import BColor from '../BColor'
import EPSList from './EPSList';

import MyLoveList from '../mylove/MyLoveList';
import FavoriteBorder from '@material-ui/icons/Build'
import { exportExcel } from '../util/ExportCSV'
import Divider from '@material-ui/core/Divider'


function desc(a, b, orderBy) {
    if (b.eps1 != null && a.eps1 != null) {
        if (b.eps1[orderBy] < a.eps1[orderBy]) {
            return -1;
        }
        if (b.eps1[orderBy] > a.eps1[orderBy]) {
            return 1;
        }
    }

    return 0;
}


function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) =>
        [el, index]);

    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}


const headCells = [
    { id: 'name', numeric: false, disablePadding: false, label: '股票代號', sid: 'name' },

    { id: 'ns', numeric: false, disablePadding: false, label: '負EPS', sid: 'ns' },
    { id: 'psp', numeric: false, disablePadding: false, label: '正YoY比例', sid: 'psp' },
    { id: 'psgr', numeric: false, disablePadding: false, label: '正QoQ比例', sid: 'psgr' },
    { id: 'savyoy', numeric: false, disablePadding: false, label: '平均YoY', sid: 'savyoy' },
    { id: 'savgr', numeric: false, disablePadding: false, label: '平均QoQ', sid: 'savgr' },
    { id: 'saveps', numeric: false, disablePadding: false, label: '平均EPS', sid: 'saveps' },

    { id: 'ny', numeric: false, disablePadding: false, label: '負EPS', sid: 'ny' },
    { id: 'pyp', numeric: false, disablePadding: false, label: '正YoY比例', sid: 'pyp' },
    { id: 'yavyoy', numeric: false, disablePadding: false, label: '平均YoY', sid: 'yavyoy' },
    { id: 'yaveps', numeric: false, disablePadding: false, label: '平均EPS', sid: 'yaveps' },

    { id: 'nseps', numeric: false, disablePadding: false, label: '近一季EPS', sid: 'nseps' },
    { id: 'nsyoy', numeric: false, disablePadding: false, label: '近一季YoY', sid: 'nsyoy' },
    { id: 'nsgr', numeric: false, disablePadding: false, label: '近一季QoQ', sid: 'nsgr' },
    { id: 'n4seps', numeric: false, disablePadding: false, label: '近四季EPS', sid: 'n4seps' },
    { id: 's4yoy', numeric: false, disablePadding: false, label: '近四季YoY', sid: 's4yoy' },
    { id: 'nyeps', numeric: false, disablePadding: false, label: '近一年EPS', sid: 'nyeps' },
    { id: 'nyyoy', numeric: false, disablePadding: false, label: '近一年YoY', sid: 'nyyoy' },

    { id: 'love', numeric: false, disablePadding: false, label: '自選清單' },
];

const color1 = BColor.blue1color// "#e0757e"
const color2 = BColor.column
const color3 = BColor.blackcolor


function EnhancedTableHead(props) {
    const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (value) => {
        if (value != null && value != '' && value.length === 4) {
            localStorage.setItem('epnow', value);
            props.freecashupdate()
        }

        setAnchorEl(null);
    };


    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };

    return (
        <TableHead style={{ background: color1 }}>
            <TableRow style={{}}>
                <TableCell className={classes.stickya1} colSpan={1} style={{ color: "#FFFFFF", borderRight: '1px solid #dbdbdb' }}>股票名稱</TableCell>
                <TableCell className={classes.stickya} colSpan={6} style={{ color: "#FFFFFF", borderLeft: '1px solid #dbdbdb' }} align="center">最近六年 - 季EPS</TableCell>
                <TableCell className={classes.stickya} colSpan={4} style={{ color: "#FFFFFF", borderLeft: '1px solid #dbdbdb' }} align="center">最近六年 - 年EPS</TableCell>
                <TableCell className={classes.stickya} colSpan={7} style={{ color: "#FFFFFF", borderLeft: '1px solid #dbdbdb' }} align="center">最近EPS</TableCell>
                <TableCell className={classes.stickya} colSpan={1} style={{ color: "#FFFFFF", borderLeft: '1px solid #dbdbdb' }} align="center"></TableCell>
            </TableRow>
            <TableRow style={{}}>
                {headCells.map(headCell => (
                    <TableCell
                        // style={{ margin: 0, paddingTop: 5, paddingBottom: 5, paddingLeft: headCell.paddingLeft, paddingRight: headCell.paddingRight }}
                        key={headCell.id}
                        className={(headCell.id === 'name' ? classes.stickyhh : classes.stickyh)}
                        style={{ ...((headCell.id === 'ny' || headCell.id === 'ns' || headCell.id === 'nseps' || headCell.id === 'love') ? { borderLeft: '1px solid #dbdbdb' } : {}) }}
                        size="small"
                        align={headCell.id === 'name' ? 'left' : 'center'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >{headCell.id === 'bname' || headCell.id === 'bname1' || headCell.id === 'bname2' ||
                        headCell.id === 'bname3' || headCell.id === 'status1' || headCell.id === 'status2' || headCell.id === 'status3'
                        || headCell.id === 'love' ? <div style={{ whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 10 }}>{headCell.label}</div> :
                        <TableSortLabel
                            style={{ whiteSpace: 'nowrap', ...(headCell.id === 'name' ? { width: 10 } : {}), }}
                            active={orderBy === headCell.id}
                            direction={order}
                            onClick={createSortHandler(headCell.sid)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                        }
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};


const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        padding: 0,
        margin: 0,
        // marginTop: theme.spacing(1),
    },
  paper: {
    width: '100%',
    backgroundColor: theme.palette.type === "light" ? "#FFFFFF" : "#000000",
  },
    table: {
        minWidth: 750,
    },
    tableWrapper: {
        // maxHeight: 550,
        overflowX: 'auto'
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },

    vvvv: {
        fontSize: 10,
        padding: 5,
        color: BColor.faircolor,
        overflow: 'visible'
    },
    button1: {
        minWidth: 110,
    },
    button2: {
        // minWidth: 90,
    },
    button3: {
        minWidth: 181,
    },
    stickyc: {
    paddingLeft: 10,
    paddingRight: 5,
    width: 10,
    whiteSpace: 'nowrap',
    position: '-webkit-sticky',
    position: 'sticky',
    zIndex: 1,
    left: 0,
    backgroundColor: theme.palette.type === "light" ? "#FFFFFF" : "#000000",
  },
    stickya: {
        background: color3,
        color: "#FFFFFF",
        position: '-webkit-sticky',
        position: 'sticky',
        height: 35,
        zIndex: 10,
        top: 0,
        paddingTop: 7,
        paddingBottom: 7,
        paddingLeft: 10,
        padding: 0,
        borderBottom: '1px solid #dbdbdb'
    },
stickyh: {
    backgroundColor: theme.palette.type === "light" ? color2 : "#000000",
        position: '-webkit-sticky',
        position: 'sticky',
        zIndex: 10,
        top: 37,
        paddingTop: 7,
        paddingBottom: 7,
        paddingLeft: 10,
        padding: 0
    }, //This is header
    stickya1: {
        backgroundColor: color3,
        color: "#FFFFFF",
        position: '-webkit-sticky',
        position: 'sticky',
        height: 35,
        zIndex: 20,
        top: 0,
        left: 0,
        paddingTop: 7,
        paddingBottom: 0,
        paddingLeft: 8,
        paddingRight: 8,
        whiteSpace: 'nowrap',
        padding: 0,
        borderBottom: '0px solid #dbdbdb'
    },
    stickyhh: {
        backgroundColor: color3,
        color: "#FFFFFF",
        position: '-webkit-sticky',
        position: 'sticky',
        top: 37,
        left: 0,
        zIndex: 20,
        paddingTop: 0,
        paddingBottom: 7,
        paddingLeft: 8,
        paddingRight: 8,
        whiteSpace: 'nowrap',
        padding: 0,
        borderTop: '0px',
        borderRight: '1px solid #dbdbdb',
        borderBottom: '1px solid #dbdbdb'
    }
}));



function EPSDetail1(props) {
    let redcolor = BColor.upcolorbox
    let greencolor = BColor.downcolorbox
    let cellpadding = 5

    const classes = useStyles();
    const loveItems = localStorage.getItem('love_stock') != null ? JSON.parse(localStorage.getItem('love_stock')) : []

    const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = React.useState('');
    const [selected, setSelected] = React.useState(loveItems);
    const [page, setPage] = React.useState(props.currentpage);
    const [dense, setDense] = React.useState(props.dense);
    const [rowsPerPage, setRowsPerPage] = React.useState(props.currentcount);

    const [getStock, setSavestock] = React.useState(null);

    const [opendetail, setOpendetail] = React.useState(false)
    const [stockno, setStockNo] = React.useState(null);


    const [openstock, setOpenstock] = React.useState(null);
    const [concentopen, setConcentOpen] = React.useState(false);
    const [lovemenu, setLovemenu] = React.useState(false)
    const myContainer = React.useRef(null);

    const handleLoveClick = stockNo => event => {
        setSavestock(stockNo);
        setLovemenu(true);
    };

    const handleLoveClose = () => {
        setLovemenu(false);
    };

    const handleClickOpencc = (stock_no) => event => {
        setOpenstock(stock_no)
        setConcentOpen(true);
    };

    const handleClosecc = () => {
        setOpenstock(null)
        setConcentOpen(false);
    };



    function getRowPageData(screen) {
        if (screen === 'xs')
            return [20]
        else return [10, 20, 40, 80, 150];
    }

    const rows = props.data

    const handleRequestSort = (event, property) => {
        const isDesc = orderBy === property && order === 'desc';
        setOrder(isDesc ? 'asc' : 'desc');
        setOrderBy(property);
    };

    const handleSelectAllClick = event => {
        if (event.target.checked) {
            const newSelecteds = rows.map(n => n.stock_no);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        props.pageupdate(newPage, props.currentcount)
    };

    const handleChangeRowsPerPage = event => {
        setPage(0)
        setRowsPerPage(parseInt(event.target.value, 10));
        props.pageupdate(0, parseInt(event.target.value, 10))
    };

    const openDetail = (stockno) => {
        if (props.detailUpdate!= undefined) props.detailUpdate(true)
        setStockNo(stockno)
        setOpendetail(true)
    }

    const closeDetail = () => {
        if (props.closeupdate != undefined) props.closeupdate()
        if (props.detailUpdate!= undefined) props.detailUpdate(false)
        setOpendetail(false)
    }




    const renderNValue = (value, stockno) => {
        let color = BColor.faircolor

        if (value > 0) {
            return <Button size="small" onClick={handleClickOpencc(stockno)} variant="outlined" style={{ minWidth: 110, color: greencolor }} className={classes.button2} >
                {value}次
        </Button>
        } else {
            return <Button size="small" onClick={handleClickOpencc(stockno)} variant="outlined" style={{ minWidth: 110, color: color }} className={classes.button2} >
                {value}次
        </Button>
        }
    }

    const renderPValue = (value, base, stockno) => {
        let color = BColor.faircolor

        if (value > base) {
            return <Button size="small" onClick={handleClickOpencc(stockno)} variant="outlined" style={{ minWidth: 110, color: redcolor }} className={classes.button2} >
                {value}%
        </Button>
        } else {
            return <Button size="small" onClick={handleClickOpencc(stockno)} variant="outlined" style={{ minWidth: 110, color: color }} className={classes.button2} >
                {value}%
        </Button>
        }
    }

    const rendereps1 = (index, value, stockno) => {
        if (index === 0) {
            let color = BColor.nodatacolor
            let bcolor = "#FFFFFF"
            if (value >= 0 && value < 100) {
                color = BColor.upcolorbox
            } else if (value >= 100) {
                color = "#FFFFFF"
                bcolor = BColor.upcolorbox
            } else if (value < 0 && value > -100) {
                color = BColor.downcolorbox
            } else if (value < -100) {
                color = "#FFFFFF"
                bcolor = BColor.downcolorbox
            }

            return <Button size="small" variant="outlined" onClick={handleClickOpencc(stockno)} style={{ whiteSpace: "nowrap", minWidth: 90, backgroundColor: bcolor, color: color }} className={classes.button1} >
                {value}%
          </Button>
        } else if (index === 1) {
            return <Button size="small" variant="outlined" style={{ whiteSpace: "nowrap", minWidth: 90, color: BColor.downcolorbox }} className={classes.button1}>盈轉虧</Button>
        } else if (index === 2) {
            return <Button size="small" variant="outlined" style={{ whiteSpace: "nowrap", minWidth: 90, color: BColor.upcolorbox }} className={classes.button1}>虧轉盈</Button>
        } else if (index === 3) {
            return <Button size="small" variant="outlined" style={{ whiteSpace: "nowrap", minWidth: 90, color: BColor.downcolorbox }} className={classes.button1} >虧轉虧</Button>
        } else {
            return <Button size="small" variant="outlined" style={{ whiteSpace: "nowrap", minWidth: 90, color: BColor.nodatacolor }} className={classes.button1} >-</Button>
        }
    }

    const renderee = (title, value, stockno) => {
        let color = BColor.faircolor
        if (value === -99999.0) {
            return <Button size="small" onClick={handleClickOpencc(stockno)} variant="outlined" style={{ minWidth: 120, color: color }} className={classes.button2} >
                -
        </Button>
        } else {
            return <Button size="small" onClick={handleClickOpencc(stockno)} variant="outlined" style={{ minWidth: 120, color: color }} className={classes.button2} >
                {title}{value}元
        </Button>
        }
    }

    const getAllIds = () => {
        return props.data.map (row => {
          return row.market_company.stock_no
        })
      }
      
    return (
        <div className={classes.root}>
            <StockDetail open={opendetail} allIds={getAllIds()}  handleClose={closeDetail} stockno={stockno} ismobile={props.ismobile}/>
            <MyLoveList open={lovemenu} handleClose={handleLoveClose} stockno={getStock} myloveupdate={props.myloveupdate} />

            <Paper className={classes.paper}>
                <div className={classes.tableWrapper}
                    style={{ ...((localStorage.getItem('hfix') == null || localStorage.getItem('hfix') === "y") ? { maxHeight: '70vh' } : {}) }}
                >
                    <Table
                        ref={myContainer}
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        size={dense ? 'small' : 'medium'}
                    >

                        <EnhancedTableHead
                            classes={classes}
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={rows.length}
                            freecashupdate={props.freecashupdate}

                        />
                        <TableBody>
                            {stableSort(rows, getSorting(order, orderBy))
                                .map((row, index) => {
                                    //   const isItemSelected = isSelected(row.stock_no);

                                    return (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            tabIndex={-1}
                                            key={row.market_company.stock_no}
                                        >
                                            <TableCell className={classes.stickyc} style={{ borderRight: '1px solid #dbdbdb', borderBottom: '1px solid #d9d9d9' }} padding="none" size="small" align="left">
                                                <Link
    component="button"
    variant="body2"
    onClick={() => {
        openDetail(row.market_company.stock_no)
    }}
    color="inherit"
>{row.market_company.short_name}
</Link>
                                                <br />
                                                <Link
                                                    style={{ color: BColor.upcolor }}
                                                    component="button"
                                                    variant="caption"
                                                    onClick={() => openDetail(row.market_company.stock_no)}
                                                >
                                                    {row.market_company.stock_no}
                                                </Link>
                                            </TableCell>

                                            {row.eps1 != null && row.eps1 != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 5, borderLeft: '1px solid #dbdbdb' }} size="small" align="left">
                                                {renderNValue(row.eps1.ns, row.market_company.stock_no)}
                                            </TableCell> : <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: cellpadding, paddingRight: cellpadding, borderLeft: '1px solid #dbdbdb' }} size="small" align="left">
                                                    <Button size="small" variant="outlined" style={{ minWidth: 110, color: BColor.faircolor }} className={classes.button2} >
                                                        -
                                                    </Button>
                                                </TableCell>}
                                            {row.eps1 != null && row.eps1 != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 5 }} size="small" align="left">
                                                {renderPValue(row.eps1.psp, 50, row.market_company.stock_no)}
                                            </TableCell> : <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 5 }} size="small" align="left">
                                                    <Button size="small" variant="outlined" style={{ minWidth: 110, color: BColor.faircolor }} className={classes.button2} >
                                                        -
                                                    </Button>
                                                </TableCell>}
                                            {row.eps1 != null && row.eps1 != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 5 }} size="small" align="left">
                                                {renderPValue(row.eps1.psgr, 50, row.market_company.stock_no)}
                                            </TableCell> : <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 5 }} size="small" align="left">
                                                    <Button size="small" variant="outlined" style={{ minWidth: 110, color: BColor.faircolor }} className={classes.button2} >
                                                        -
                                                    </Button>
                                                </TableCell>}
                                            {row.eps1 != null && row.eps1 != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 5 }} size="small" align="left">
                                                {renderPValue(row.eps1.savyoy, 50, row.market_company.stock_no)}
                                            </TableCell> : <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 5 }} size="small" align="left">
                                                    <Button size="small" variant="outlined" style={{ minWidth: 110, color: BColor.faircolor }} className={classes.button2} >
                                                        -
                                                    </Button>
                                                </TableCell>}
                                            {row.eps1 != null && row.eps1 != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 5 }} size="small" align="left">
                                                {renderPValue(row.eps1.savgr, 50, row.market_company.stock_no)}
                                            </TableCell> : <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 5 }} size="small" align="left">
                                                    <Button size="small" variant="outlined" style={{ minWidth: 110, color: BColor.faircolor }} className={classes.button2} >
                                                        -
                                                    </Button>
                                                </TableCell>}
                                            {row.eps1 != null && row.eps1 != undefined ? <TableCell style={{ whiteSpace: 'nowrap' }} size="small" align="right">
                                                {row.eps1.saveps}元
                                            </TableCell> : <TableCell style={{ whiteSpace: 'nowrap' }} size="small" align="left">
                                                    <Button size="small" variant="outlined" style={{ minWidth: 110, color: BColor.faircolor }} className={classes.button2} >
                                                        -
                                                    </Button>
                                                </TableCell>}




                                            {row.eps1 != null && row.eps1 != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 10, paddingRight: 5, borderLeft: '1px solid #dbdbdb' }} size="small" align="left">
                                                {renderNValue(row.eps1.ny, row.market_company.stock_no)}
                                            </TableCell> : <TableCell style={{ whiteSpace: 'nowrap', borderLeft: '1px solid #dbdbdb', paddingLeft: 5, paddingRight: 5 }} size="small" align="left">
                                                    <Button size="small" variant="outlined" style={{ minWidth: 110, color: BColor.faircolor }} className={classes.button2} >
                                                        -
                                                    </Button>
                                                </TableCell>}
                                            {row.eps1 != null && row.eps1 != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 5 }} size="small" align="left">
                                                {renderPValue(row.eps1.pyp, 50, row.market_company.stock_no)}
                                            </TableCell> : <TableCell style={{ whiteSpace: 'nowrap', borderLeft: '1px solid #dbdbdb' }} size="small" align="left">
                                                    <Button size="small" variant="outlined" style={{ minWidth: 110, color: BColor.faircolor }} className={classes.button2} >
                                                        -
                                                    </Button>
                                                </TableCell>}

                                            {row.eps1 != null && row.eps1 != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 5 }} size="small" align="left">
                                                {renderPValue(row.eps1.yavyoy, 50, row.market_company.stock_no)}
                                            </TableCell> : <TableCell style={{ whiteSpace: 'nowrap', borderLeft: '1px solid #dbdbdb' }} size="small" align="left">
                                                    <Button size="small" variant="outlined" style={{ minWidth: 110, color: BColor.faircolor }} className={classes.button2} >
                                                        -
                                                    </Button>
                                                </TableCell>}
                                            {row.eps1 != null && row.eps1 != undefined ? <TableCell style={{ whiteSpace: 'nowrap' }} size="small" align="right">
                                                {row.eps1.yaveps}元
                                            </TableCell> : <TableCell style={{ whiteSpace: 'nowrap', borderLeft: '1px solid #dbdbdb' }} size="small" align="left">
                                                    <Button size="small" variant="outlined" style={{ minWidth: 110, color: BColor.faircolor }} className={classes.button2} >
                                                        -
                                                    </Button>
                                                </TableCell>}


                                            {row.eps1 != null && row.eps1 != undefined ? <TableCell style={{ whiteSpace: 'nowrap', borderLeft: '1px solid #dbdbdb', paddingLeft: 10, paddingRight: 5 }} size="small" align="left">
                                                {renderee(row.eps1.st, row.eps1.nseps, row.market_company.stock_no)}
                                            </TableCell> : <TableCell style={{ whiteSpace: 'nowrap', borderLeft: '1px solid #dbdbdb', paddingLeft: 10, paddingRight: 5 }} size="small" align="left">
                                                    <Button size="small" variant="outlined" style={{ minWidth: 110, color: BColor.faircolor }} className={classes.button2} >
                                                        -
                                                    </Button>
                                                </TableCell>}
                                            {row.eps1 != null && row.eps1 != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 5 }} size="small" align="left">
                                                {rendereps1(row.eps1.nsyoyi, row.eps1.nsyoy, row.market_company.stock_no)}
                                            </TableCell> : <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 5 }} size="small" align="left">
                                                    <Button size="small" variant="outlined" style={{ minWidth: 110, color: BColor.faircolor }} className={classes.button2} >
                                                        -
                                                    </Button>
                                                </TableCell>}
                                            {row.eps1 != null && row.eps1 != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 5 }} size="small" align="left">
                                                {rendereps1(row.eps1.nsgri, row.eps1.nsgr, row.market_company.stock_no)}
                                            </TableCell> : <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 5 }} size="small" align="left">
                                                    <Button size="small" variant="outlined" style={{ minWidth: 110, color: BColor.faircolor }} className={classes.button2} >
                                                        -
                                                    </Button>
                                                </TableCell>}
                                            {row.eps1 != null && row.eps1 != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 10 }} size="small" align="right">
                                                {row.eps1.n4seps}元
                                            </TableCell> : <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 10 }} size="small" align="left">
                                                    <Button size="small" variant="outlined" style={{ minWidth: 110, color: BColor.faircolor }} className={classes.button2} >
                                                        -
                                                    </Button>
                                                </TableCell>}

                                            {row.eps1 != null && row.eps1 != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 5 }} size="small" align="left">
                                                {rendereps1(row.eps1.s4yoyi, row.eps1.s4yoy, row.market_company.stock_no)}
                                            </TableCell> : <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 5 }} size="small" align="left">
                                                    <Button size="small" variant="outlined" style={{ minWidth: 110, color: BColor.faircolor }} className={classes.button2} >
                                                        -
                                                    </Button>
                                                </TableCell>}

                                            {row.eps1 != null && row.eps1 != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 5 }} size="small" align="left">
                                                {renderee(row.eps1.yt, row.eps1.nyeps, row.market_company.stock_no)}
                                            </TableCell> : <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 5 }} size="small" align="left">
                                                    <Button size="small" variant="outlined" style={{ minWidth: 110, color: BColor.faircolor, paddingLeft: 5, paddingRight: 5 }} className={classes.button2} >
                                                        -
                                                    </Button>
                                                </TableCell>}
                                            {row.eps1 != null && row.eps1 != undefined ? <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 10 }} size="small" align="left">
                                                {rendereps1(row.eps1.nyyoyi, row.eps1.nyyoy, row.market_company.stock_no)}
                                            </TableCell> : <TableCell style={{ whiteSpace: 'nowrap', paddingLeft: 5, paddingRight: 10 }} size="small" align="left">
                                                    <Button size="small" variant="outlined" style={{ minWidth: 110, color: BColor.faircolor }} className={classes.button2} >
                                                        -
                                                    </Button>
                                                </TableCell>}

                                                <TableCell style={{ whiteSpace: 'nowrap', borderLeft: '1px solid #dbdbdb', paddingLeft: 5, paddingRight: 5 }} align="center">
                                                <Button
                                                    size="small"
                                                    onClick={handleLoveClick(row.market_company.stock_no)}
                                                    variant="outlined"
                                                    style={{ width: '100%', color: BColor.faircolor }}
                                                    className={classes.button}
                                                    startIcon={<FavoriteBorder />}
                                                >
                                                    管理
                                                </Button>
                                            </TableCell>

                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                    <EPSList open={concentopen} handleClose={handleClosecc} stockId={openstock}></EPSList>
                    
                </div>
                {props.disablepage ?
                    <div><Button size="small" className={classes.button} onClick={e => exportExcel(myContainer.current)}>
                    匯出
                  </Button></div>
                    : <div style={{ display: "flex", justifyContent: 'flex-end' }}>
                    <Divider orientation="vertical" flexItem />
                    <Button size="small" className={classes.button} onClick={e => exportExcel(myContainer.current)}>
                      匯出
                    </Button>
                    <Divider orientation="vertical" flexItem />
                    <TablePagination
                      rowsPerPageOptions={getRowPageData(props.width)}
                      component="div"
                      count={props.total}
                      rowsPerPage={props.currentcount}
                      page={props.currentpage}
                      labelRowsPerPage={'每頁'}
                      labelDisplayedRows={({ from, to, count }) => `第${from}筆，共 ${count}筆`}
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                    /></div>
                }
            </Paper>
        </div>
    );
}

export default withWidth()(EPSDetail1);
